import { render, staticRenderFns } from "./weeklyBarChart.vue?vue&type=template&id=803620de&scoped=true"
import script from "./weeklyBarChart.vue?vue&type=script&lang=js"
export * from "./weeklyBarChart.vue?vue&type=script&lang=js"
import style0 from "./weeklyBarChart.vue?vue&type=style&index=0&id=803620de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "803620de",
  null
  
)

export default component.exports